import { BrowserRouter, Route, Routes } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp } from "antd";

import CreateClaim from "./pages/claim/view/CreateClaim";
import Claim from "./pages/claim/view/index";
import UpdateClaim from "./pages/claim/view/UpdateClaim";
import Dashboard from "./pages/dashboard/view/index";
import FileCreate from "./pages/files/view/CreateFile";
import FilesDetails from "./pages/files/view/FileInfo";
import Files from "./pages/files/view/index";
import FileStatus from "./pages/files/view/StatusFile";
import FileUpdate from "./pages/files/view/UpdateFile";
import ForgotPassword from "./pages/forgotPassword/index";
import LeaveCreate from "./pages/leave/view/CreateLeave";
import Leave from "./pages/leave/view/index";
import LeaveUpdate from "./pages/leave/view/UpdateLeave";
import Login from "./pages/login/index";
import NotFoundPage from "./pages/notFoundPage/notFoundPage";
import PayslipCreate from "./pages/payslip/view/CreatePayslip";
import Payslip from "./pages/payslip/view/index";
import PayslipUpdate from "./pages/payslip/view/UpdatePayslip";
import Register from "./pages/register/index";
import ResetPassword from "./pages/resetPassword/index";
import UserCreate from "./pages/user/view/CreateUser";
import UserManagement from "./pages/user/view/index";
import UserUpdate from "./pages/user/view/UpdateUser";
import VerifyEmail from "./pages/verifyEmail/index";
import { PrivateRoute, PublicRoute } from "./utils/routeHandlers";

const queryClient = new QueryClient();

const App = () => {
  return (
    <AntApp>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/">
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path="/login" Component={Login} />
              <Route path="/" Component={Login} />
              <Route path="/register" Component={Register} />
              <Route path="/forgot-password" Component={ForgotPassword} />
              <Route path="/reset-password" Component={ResetPassword} />
              <Route path="/verify-email" Component={VerifyEmail} />
            </Route>
            <Route path="/*" element={<PrivateRoute />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="users/new" element={<UserCreate />} />
              <Route path="users/:id" element={<UserUpdate />} />
              <Route path="files" element={<Files />} />
              <Route path="files/new" element={<FileCreate />} />
              <Route path="files/:id" element={<FilesDetails />} />
              <Route path="files/:id/edit" element={<FileUpdate />} />
              <Route path="files/:id/status" element={<FileStatus />} />
              <Route path="leaves" element={<Leave />} />
              <Route path="leaves/apply" element={<LeaveCreate />} />
              <Route path="leaves/:id/edit" element={<LeaveUpdate />} />
              <Route path="claims" element={<Claim />} />
              <Route path="claims/new" element={<CreateClaim />} />
              <Route path="claims/:id/edit" element={<UpdateClaim />} />
              <Route path="payslips" element={<Payslip />} />
              <Route path="payslips/new" element={<PayslipCreate />} />
              <Route path="payslips/:id/edit" element={<PayslipUpdate />} />
            </Route>
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </AntApp>
  );
};

export default App;
